// The 'Your Content' Page Actions
export const INITIALIZE_THE_YOUR_CONTENT_PAGE = 'INITIALIZE_THE_YOUR_CONTENT_PAGE';
export const BOOKMARKED_ARTICLE_HEADERS_FETCH_REQUEST = 'BOOKMARKED_ARTICLE_HEADERS_FETCH_REQUEST';
export const BOOKMARKED_ARTICLE_HEADERS_FETCH_SUCCESS = 'BOOKMARKED_ARTICLE_HEADERS_FETCH_SUCCESS';
export const BOOKMARKED_ARTICLE_HEADERS_FETCH_FAILURE =
'BOOKMARKED_ARTICLE_HEADERS_FETCH_FAILURE';
export const TEXT_SETS_FETCH_REQUEST = 'TEXT_SETS_FETCH_REQUEST';
export const BOOKMARKED_TEXT_SETS_FETCH_SUCCESS = 'BOOKMARKED_TEXT_SETS_FETCH_SUCCESS';
export const BOOKMARKED_TEXT_SETS_FETCH_FAILURE = 'BOOKMARKED_TEXT_SETS_FETCH_FAILURE';
export const USER_TEXT_SETS_FETCH_SUCCESS = 'USER_TEXT_SETS_FETCH_SUCCESS';
export const USER_TEXT_SETS_FETCH_FAILURE = 'USER_TEXT_SETS_FETCH_FAILURE';
export const SCHOOL_TEXT_SETS_FETCH_SUCCESS = 'SCHOOL_TEXT_SETS_FETCH_SUCCESS';
export const SCHOOL_TEXT_SETS_FETCH_FAILURE = 'SCHOOL_TEXT_SETS_FETCH_FAILURE';
export const BOOKMARKED_STANDARDS_FETCH_REQUEST = 'BOOKMARKED_STANDARDS_FETCH_REQUEST';
export const BOOKMARKED_STANDARDS_FETCH_SUCCESS =
'BOOKMARKED_STANDARDS_FETCH_SUCCESS';
export const BOOKMARKED_STANDARDS_FETCH_FAILURE =
'BOOKMARKED_STANDARDS_FETCH_FAILURE';
